<div class="payment-page">
  <!-- Page Header -->
  <section class="page-header bg-dark with-grid-overlay">
    <div class="page-container">
      <div class="page-header-content">
      <h1 class="page-title">Complete Your Purchase</h1>
      <p class="page-subtitle">Start creating your professional digital visiting card today</p>
      </div>
    </div>
  </section>

<section class="page-section payment-section bg-white" id="payment">
 
  <!-- Main Payment Content -->
  <div class="payment-content">
    <!-- Create Your Account Section (Left) -->
    <div class="payment-form-section">
    <div class="form-card">
      <h2 class="form-title">Create Your Account</h2>

      <form class="payment-form" (ngSubmit)="processPayment()">
        <!-- vCard Type Selection -->
        <div class="form-group">
          <label class="form-label">vCard Type *</label>
          <div class="vcard-type-selection">
            <div
              class="vcard-option"
              [class.selected]="signupForm.vcardType === 'individual'"
              (click)="onVCardTypeChange('individual')"
            >
              <div class="vcard-radio">
                <input
                  type="radio"
                  id="individual"
                  name="vcardType"
                  value="individual"
                  [checked]="signupForm.vcardType === 'individual'"
                />
              </div>
              <div class="vcard-content">
                <div class="vcard-name">Individual</div>
                <div class="vcard-description">
                  Personal digital business card (1 card)
                </div>
                <div class="vcard-pricing">
                  <div class="discounted-price">₹{{ formatIndianCurrency(3999) }} per card</div>
                  <div class="offer-badge">� Premium Individual Card</div>
                </div>
              </div>
            </div>

            <div
              class="vcard-option"
              [class.selected]="signupForm.vcardType === 'business'"
              (click)="onVCardTypeChange('business')"
            >
              <div class="vcard-radio">
                <input
                  type="radio"
                  id="business"
                  name="vcardType"
                  value="business"
                  [checked]="signupForm.vcardType === 'business'"
                />
              </div>
              <div class="vcard-content">
                <div class="vcard-name">Business</div>
                <div class="vcard-description">
                  Corporate digital business cards (10-1000 cards)
                </div>
                <div class="vcard-pricing">
                  <div class="discounted-price">₹{{ formatIndianCurrency(999) }} - ₹{{ formatIndianCurrency(499) }} per card</div>
                  <div class="offer-badge">🚀 Bulk Discounts Available!</div>
                  <div class="pricing-note">*Up to 50% off for 1000+ cards</div>
                </div>
              </div>
            </div>

            <div
              class="vcard-option"
              [class.selected]="signupForm.vcardType === 'agency'"
              (click)="onVCardTypeChange('agency')"
            >
              <div class="vcard-radio">
                <input
                  type="radio"
                  id="agency"
                  name="vcardType"
                  value="agency"
                  [checked]="signupForm.vcardType === 'agency'"
                />
              </div>
              <div class="vcard-content">
                <div class="vcard-name">Agency</div>
                <div class="vcard-description">Bulk digital business cards (1000 cards)</div>
                <div class="vcard-pricing">
                  <div class="discounted-price">₹{{ formatIndianCurrency(499) }} per card</div>
                  <div class="offer-badge">💎 Agency Special Rate!</div>
                  <div class="pricing-note">*Bulk 1000 cards included</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card Count Selection (Only for Business) -->
        @if (signupForm.vcardType === 'business') {
        <div class="form-group">
          <label for="cardCount" class="form-label">Number of Cards *</label>
          <select
            id="cardCount"
            class="form-input"
            [(ngModel)]="signupForm.cardCount"
            name="cardCount"
            (change)="onCardCountChange(signupForm.cardCount)"
          >
            @for (option of availableCardCounts; track option.count) {
            <option [value]="option.count">{{ option.display }}</option>
            }
          </select>
        </div>
        }

        <!-- Personal Information -->
        <div class="form-group">
          <label for="name" class="form-label">Full Name *</label>
          <input
            type="text"
            id="name"
            class="form-input"
            [(ngModel)]="signupForm.name"
            name="name"
            placeholder="Enter your full name"
            required
          />
        </div>

        <div class="form-group">
          <label for="email" class="form-label">Email Address *</label>
          <input
            type="email"
            id="email"
            class="form-input"
            [(ngModel)]="signupForm.email"
            name="email"
            placeholder="Enter your email address"
            required
          />
        </div>

        <div class="form-group">
          <label for="phone" class="form-label">Phone Number *</label>
          <input
            type="tel"
            id="phone"
            class="form-input"
            [(ngModel)]="signupForm.phone"
            name="phone"
            placeholder="Enter your phone number"
            required
          />
        </div>

        <!-- Payment Button -->
        <div class="payment-actions">
          <button
            type="submit"
            class="payment-button"
            [disabled]="!validateForm() || isProcessingPayment"
            [class.processing]="isProcessingPayment"
          >
            @if (isProcessingPayment) {
            <span class="loading-spinner"></span>
            Processing Payment... } @else {
            <span class="button-icon">🔒</span>
            @if (packDetails) { Secure Payment - {{ packDetails.currencySymbol
            }}{{ formatIndianCurrency(packDetails.total) }}
            } @else { Select a Package } }
          </button>

          <div class="security-info">
            <div class="security-item">
              <span class="security-icon">🔒</span>
              <span class="security-text">256-bit SSL Encryption</span>
            </div>
            <div class="security-item">
              <span class="security-icon">✅</span>
              <span class="security-text">100% Secure Payment</span>
            </div>
            <div class="security-item">
              <span class="security-icon">💰</span>
              <span class="security-text">Money Back Guarantee</span>
            </div>
          </div>
        </div>
      </form>

      <!-- Alternative Action -->
      <div class="alternative-action">
        <p class="alternative-text">Need help or have questions?</p>
        <button class="alternative-button" (click)="openWebPlatformDirectly()">
          Contact Support
        </button>
      </div>
    </div>
    </div>

    <!-- Order Summary Section (Right) -->
    @if (signupForm.vcardType) {
    <div class="pack-summary">
      <div class="summary-card">
        <div class="summary-header">
          <h2 class="summary-title">Order Summary</h2>
          <div class="selected-pack">
            <span class="pack-name">{{ signupForm.vcardType | titlecase }} vCard</span>
            <span class="pack-quantity">({{ signupForm.cardCount }} cards)</span>
          </div>
        </div>

        <div class="pack-features">
          <h3 class="features-title">What's Included:</h3>
          <ul class="features-list">
            @for (feature of packDetails.features; track feature) {
            <li class="feature-item">
              <span class="feature-icon">✅</span>
              {{ feature }}
            </li>
            }
          </ul>
        </div>

        <div class="cost-breakdown">
          @if (packDetails.savings > 0) {
          <div class="cost-item">
            <span class="cost-label">Original Price:</span>
            <span class="cost-value original-price-strike"
              >{{ packDetails.currencySymbol
              }}{{ formatIndianCurrency(packDetails.originalPrice * packDetails.quantity) }}</span
            >
          </div>
          <div class="cost-item savings">
            <span class="cost-label">You Save:</span>
            <span class="cost-value savings-amount"
              >{{ packDetails.currencySymbol
              }}{{ formatIndianCurrency(packDetails.savings) }}</span
            >
          </div>
          }
          <div class="cost-item">
            <span class="cost-label">Package Price:</span>
            <span class="cost-value"
              >{{ packDetails.currencySymbol
              }}{{ formatIndianCurrency(packDetails.discountedPrice) }}</span
            >
          </div>
          <div class="cost-item">
            <span class="cost-label">GST (18%):</span>
            <span class="cost-value"
              >{{ packDetails.currencySymbol
              }}{{ formatIndianCurrency(packDetails.gst) }}</span
            >
            </div>
          <div class="cost-item total">
            <span class="cost-label">Total Amount:</span>
            <span class="cost-value"
              >{{ packDetails.currencySymbol
              }}{{ formatIndianCurrency(packDetails.total) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</section>
